/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeResponseDto
 */
export interface PartnerMaintenanceScopeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeResponseDto
     */
    dimension: PartnerMaintenanceScopeResponseDtoDimensionEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeResponseDto
     */
    effect: PartnerMaintenanceScopeResponseDtoEffectEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeResponseDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeResponseDto
     */
    interventionMode?: PartnerMaintenanceScopeResponseDtoInterventionModeEnum | null;
}


/**
 * @export
 */
export const PartnerMaintenanceScopeResponseDtoDimensionEnum = {
    Manufacturer: 'MANUFACTURER',
    Model: 'MODEL',
    Commune: 'COMMUNE',
    Asset: 'ASSET'
} as const;
export type PartnerMaintenanceScopeResponseDtoDimensionEnum = typeof PartnerMaintenanceScopeResponseDtoDimensionEnum[keyof typeof PartnerMaintenanceScopeResponseDtoDimensionEnum];

/**
 * @export
 */
export const PartnerMaintenanceScopeResponseDtoEffectEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;
export type PartnerMaintenanceScopeResponseDtoEffectEnum = typeof PartnerMaintenanceScopeResponseDtoEffectEnum[keyof typeof PartnerMaintenanceScopeResponseDtoEffectEnum];

/**
 * @export
 */
export const PartnerMaintenanceScopeResponseDtoInterventionModeEnum = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE'
} as const;
export type PartnerMaintenanceScopeResponseDtoInterventionModeEnum = typeof PartnerMaintenanceScopeResponseDtoInterventionModeEnum[keyof typeof PartnerMaintenanceScopeResponseDtoInterventionModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceScopeResponseDto interface.
 */
export function instanceOfPartnerMaintenanceScopeResponseDto(value: object): value is PartnerMaintenanceScopeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dimension' in value) || value['dimension'] === undefined) return false;
    if (!('effect' in value) || value['effect'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeResponseDtoFromJSON(json: any): PartnerMaintenanceScopeResponseDto {
    return PartnerMaintenanceScopeResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dimension': json['dimension'],
        'effect': json['effect'],
        'value': json['value'] == null ? undefined : json['value'],
        'interventionMode': json['interventionMode'] == null ? undefined : json['interventionMode'],
    };
}

export function PartnerMaintenanceScopeResponseDtoToJSON(json: any): PartnerMaintenanceScopeResponseDto {
    return PartnerMaintenanceScopeResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeResponseDtoToJSONTyped(value?: PartnerMaintenanceScopeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dimension': value['dimension'],
        'effect': value['effect'],
        'value': value['value'],
        'interventionMode': value['interventionMode'],
    };
}

